module.exports = __webpack_public_path__ + "static/media/YF56_1.5e3e5bb4.jpg";